import React from 'react';
import { useStyle } from './Style';
import DisplayRecentPayments from './DisplayRecentPayments';
import SkeletonWrapper from '../../../containers/NewProductList/components/SkeletonWrapper/SkeletonWrapper';

const RecentPaymentsWrapper = (props) => {
  const classes = useStyle();

  if (props.loader) {
    return <SkeletonWrapper loading={props.loader} />;
  }

  return (
    <>
      <section className={classes.claimswrapper}>
        <DisplayRecentPayments
          payments={props.payments}
          loader={props.loader}
          handleNextPage={props.getPayments}
          page={props.page}
          size={props.size}
          total={props.total}
        />
      </section>
    </>
  );
};

export default RecentPaymentsWrapper;